module.exports = {
  allOfTheRemittance: "すべて",
  toBeConfirmedUrgent: "確認待ち（緊急）",
  theAmountOnTheBillIsYen: "注文・配送金額",
  remittanceInformation: "振込詳細",
  customerBalance: "残高",
  customerContactInformation: "連絡先詳細",
  theRemitter: "振込人",
  confirmToRemind: "确认提醒",
  afterConfirmationTheRemittanceAmountWillBeReflectedInTheCustomerBalancePleaseBeCareful:
    "確認後、お客様の残高に入金額が反映されますので、慎重に操作してください！",
  remittanceReturnReminder: "確認後、お客様の残高に入金額が反映されます！",
  afterConfirmationThePackingListWillBeReturnedToTheStateToBeRemittedPleaseOperateWithCaution:
    "確定後、確認待ち状態へ戻されます！！",
  money: "資金",
  contact: "連絡先",
  pleaseUploadPictures: "画像をアップロードしてください。",
  thisParameterCannotBeEmpty: "このパラメータは空にできません。",
  searchByCategory: "検索カテゴリ",
  identifyTheTimeToBePaid: "支払い時間未選択",
  categoryOfLinks: "URLのカテゴリ",
  purchaseAnAccount: "買付アカウント",
  pleaseSelectRemittanceOrder: "送金注文を選択してください。",
  confirmWhetherToRemitTheSelectedOrder: "選択した注文を送金しますか？",
  transactionNumberRemittance: "取引番号",
  remittanceCustomer: "お客様名",
  remittanceCustomerID: "お客様ID",
  confirmationOfRemittance: "汇款确认",
  pickUpContactNumber: "提货联系电话",
  addressAndRemarks: "地址和备注",
  offlinePickupRegistration: "线下提货登记",
  offlineDeliveryModification: "线下提货修改",
  operationSucceeded: "操作成功",
  theGoodsHaveBeenReceivedAndModified: "已收货修改",
  whetherToReturnGoodsToBePickedUp: "是否退回待提货",
  theFinancialDepartmentHasPaid: "财务已付款",
  underInspection: "检品中",
  categoryOfInspectionList: "检品单类别",
  generalInspectionList: "普检单",
  fineInspectionList: "精检单",
  fineCheckReworkOrder: "精检返工单",
  generalInspectionReworkOrder: "普检返工单",
  categoryOfInspectedGoods: "检品类别",
  generalQualityInspector: "普/精检员",
  clothLabelProcessingPersonnel: "布标处理人员",
  printTheInspectionList: "检品单打印",
  dataIsNull: "数据为空",
  goodsToBeSubmittedForInspection: "待提交检品",
  toBeClothLabelProcessing: "待布标处理",
  clothLabelProcessing: "布标处理中",
  productToBeInspected: "待检品复查",
  singleAttributeOfInspection: "检品单属性",
  theFirstInspection: "首检",
  theReInspection: "复检",
  puJian: "普检",
  fineScreening: "精检",
  submitTheReinspectionList: "提出复检单",
  submitTheReinspectionListP: "提出复检单（普检）",
  submitTheReinspectionListJ: "提出复检单（精检）",
  generalprecisionExamination: "普/精检",
  wovenLable: "布标",
  quantityOfGoodsToBeSubmitted: "应检数",
  numberOfItemsSubmittedForInspection: "已提交检品数",
  numberOfGeneralTestPrecisionTestProblems: "普检/精检问题数",
  numberOfLabelLayoutProblems: "布标问题数",
  clothLabelTreatment: "布标处理",
  detailsOfInspectionList: "检品单详情",
  photo: "照片",
  theBusinessEditsTheCommodityProperties: "业务编辑商品属性",
  pendingPrecisionTestNumber: "待普/精检数 ",
  numberOfLabelsToBeLaid: "待布标处理数",
  priceYuan: "价格(元)",
  pleaseEnterRemarks: "请输入备注",
  printTheShippingMarkOfTheInspectionList: "打印检品单唛头",
  cancelTheProductToBeInspected: "取消待检品",
  modifyThePendingPrecisionCheck: "修改待普/精检数",
  exampleChangeTheNumberOfLabelsToBeBlanked: "修改待布标处理数",
  pleaseFirstConfirmWithTheInspection:
    "请先和检品确认是否已经开始检品，已经开始检品的请勿取消！",
  whetherToDiscardTheInspectionList: "是否废弃检品单",
  subjectToRevisionOfPrecisionCheckNumber: "待普/精检数修改",
  confirmTheModification: "确认修改",
  doYouWantToConfirmTheModification: "是否确认修改?",
  operationDataIsNotSelected: "未选择操作数据",
  theNumberOfLabelsToBeDeployedIsChanged: "待布标处理数修改",
  numberOfLabelsToBeLaidAfterModification: "修改后待布标处理数",
  confirmToSubmitTheInspectionList: "是否确认提交检品单",
  selectionOfReasonsForReinspection: "复检原因选择",
  reasonForReinspection: "复检原因",
  whetherToClothLabels: "是否需要布标处理",
  startProcessing: "开始处理",
  inTheProcess: "处理中",
  expired: "期限切れ",
  couponsSpecifieds: "クーポン生成",
  sum: "金额",
  purchaseData: "购入数据",
  numberOfWarehousesInRakumart: "rakumart倉庫",
  numberProposed: "提出済み数",
  productName: "商品名",
  numbersCanBeProposed: "出荷可能数",
  accessories: "辅料",
  theTotalIsApproximately: "合计约为",
  normalWarehouse: "普通仓库",
  noDataYet: "暂无数据",
  loadingTheNumberOfBoxes: "装箱数量",
  Shipping: "出荷中",
  Signed: "受領済み",
  shipDate: "出荷日",
  exportExcel: "エクセル導出",
  theDeletionWasSuccessful: "删除成功",
  signatureSuccessful: "签收成功",
  pleaseSelectData: "请选择数据",
  labelInformation: "标签信息",
  quantitiesCanBeProposed: "出荷可能数",
  singlePackingNotes: "单番装箱备注",
  unfold: "展开",
  collapse: "收起",
  proposeQuantities: "提出数量",
  pleaseEnterThisParameter: "请输入这个参数",
  pleaseSelectTheLogisticsMethod: "请选择物流方式",
  confirmTheCreditingTime: "経理確認時間",
  noteDocumentsdeliveryBooks: "注文書・配送依頼書",
  billingType: "タイプ",
  residualGold: "残高",
  withdrawalHistory: "残高引き出し記録",
  initiationTime: "提出時間",
  theNumberOfTheFlow: "流水号",
  beneficiaryName: "收款户名",
  beneficiaryAccountNumber: "收款户号",
  withdrawalAmount: "提现金额",
  processingStatus: "处理状态",
  reviewTheCredentials: "查看凭证",
  subAccounts: "社員アカウント",
  login: "ユーザー名",
  clanName: "氏名",
  employeeNumber: "社員No",
  jobTitle: "役職",
  mailbox: "Email",
  prepareForTheExam: "備考欄",
  shippingAddress: "配送先管理",
  domicile: "住所",
  theNumberOfTheCorporation: "法人番号",
  depositConfirmed: "已确认入金",
  remittanceAmountYen: "汇款金额. 円",
  accountBalanceYen: "残高. 円",
  applyWithdrawalAmountYen: "申請額. 円",
  voucherForPayment: "キャプチャー",
  declineWithdrawalPrompts:
    "确认后，该提现申请将被取消。需要申请人重新提出申请，请确认！",
  refuseToSucceed: "拒绝成功!",
  estimatedDeliveryOrderAmount: "预计配送单金额",
  reasonForRejection: "取消原因",
  afterSalesNumber: "售后编号",
  afterSalesStatus: "售后状态",
  operators: "操作人员",
  display: "显示",
  notDisplayed: "不显示",
  theHeadOfTheMinisterialDivisionRevisedTheRemarks: "部长课长修改备注",
  screenshotOfCustomerFeedbackQuestionAdded: "客户反馈问题截图添加",
  afterSalesCostAdjustmentDetails: "客户反馈问题截图添加",
  whetherToConfirmTheDeletion: "是否确认删除?",
  totalAdjustments: "合计调整",
  addAClaimNote: "添加赔款单",
  compensationCap: "赔款上限",
  categoryOfResponsiblePerson: "责任人类别",
  theOrganizationOfTheResponsiblePerson: "责任人所在组织",
  companyEmployees: "公司员工",
  externalLogisticsCompanies: "外部物流公司",
  thirdPartySellers: "第三方卖家",
  selectionOfResponsiblePersons: "责任人选择",
  detailsOfExpensesToBear: "承担费用明细",
  responsiblePersonRole: "责任人角色",
  proportionOfCommitment: "承担比例",
  amountToBeCommitted: "承担金额",
  dutyBearers: "责任承担人",
  associatedResponsiblePerson: "关联责任人",
  companyUndertakes: "公司承担",
  theSumOfTheCompensationRatiosIs100: "赔款比例总和为100",
  firm: "公司",
  confirmationOfCompensation: "赔款确认",
  whetherToConfirmTheClaimNote: "是否确认该赔款单",
  doYouConfirm: "是否确认?",
  isItConfirmedComplete: "是否确认完成?",
  whetherToConfirmTheModification: "是否确认修改?",
  feedback: "意见反馈",
  pleaseEnterTheCustomerID: "请输入客户ID",
  pleaseEnterTheCustomerName: "请输入客户名称",
  correspondingPerson: "对应人员",
  pageLink: "页面链接",
  workWithNotes: "处理备注",
  confirmTheStatus: "确认状态",
  pleaseEnterTheTrackingNumber: "请输入配送单号",
  evaluationTime: "评价时间",
  customerTestimonials: "客户评价",
  overallProductSatisfaction: "商品整体满意度",
  overallServiceSatisfaction: "服务整体满意度",
  logisticsSatisfaction: "物流满意度",
  viewTheDeliveryNote: "查看配送单",
  satisfactionIs1To5Stars: "满意度为1到5星，星级越高越满意",
  whetherTheProductPackagingIsSatisfactory: "商品包装是否满意",
  whetherTheProductIsComplete: "商品是否完整（有无缺失，破损）",
  whetherTheServiceStaffIsInPlaceToMeetYourNeeds:
    "服务人员是否能精准到位满足您的需求",
  whetherTheServiceStaffHasAGoodAttitude: "服务人员是否态度良好",
  whetherTheServiceStaffHandledTheProblemInATimelyManner:
    "服务人员是否处理问题及时",
  whetherYouAreSatisfiedWithTheSpeedOfThisLogistics: "对此物流速度是否满意",
  whetherTheLogisticsService: "物流服务（通关，配送等）是否满意",
  whetherTheLogisticsCostsAreSatisfactory: "物流费用是否满意",
  whetherTheQualityOfTheProductMeetsYourExpectations:
    "商品质量是否符合您的预期",
  overallEvaluationOfTheDeliveryOrder: "配送单整体评价",
  haveAComplaint: "有投诉",
  noComplaint: "无投诉",
  excelImport: "Excelインポート",
  pleaseSelectAtLeastOneProduct: "少なくとも1つの商品を選択してください",
  areYouSureToDeleteTheSelectedProduct: "選択した商品を削除しますか？",
  theProducerProducts:
    "URL無効、こちらの商品は既に在庫切れ、店舗から棚卸しされている状態です。\n" +
    "\n" +
    "1688またはタオバオで問題なく確認できる場合は担当者までご連絡ください。\n" +
    "個別で確認させていただきます。",
  pleaseEnterThe1688LiinAKUMARTLink:
    "1688、taobaoまたはRAKUMARTのURLを入力してください",
  addARow: "追加",
  pleaseSelect: "選択してください",
  fbaCode: "FBA码",
  productName: "商品名",
  pleaseEnterTheManagementNumber: "管理番号を入力してください",
  enterRemarks: "備考を入力してください",
  labelInformation: "ラベル情報",
  pleaseUploadPictures: "画像をアップロードしてください",
  photoUploadingInProgress: "写真上传中",
  // ----------------
  pleaseDownloadTUploadTheFile:
    "Excelのテンプレートをダウンロードして、ファイルをアップロードしてください",
  downloadTemplate: "テンプレートをダウンロード",
  pleaseSelectTheUploadFile: "アップロードするファイルを選択してください",
  fileFormatLimitedToXlsAndXlsxOnly:
    "ファイル形式はXlsおよびXlsxのみ対応しています",
  afterSuccestentOfTheFile:
    "ファイルが正常に解析されると、商品は直接商品ライブラリに表示されます。重複する商品はファイルの編集内容に従って上書きされます",
  fileUploadInProgress: "ファイルのアップロード中",
  productInquiry: '商品問い合わせ',
  inquiryQuestion: '問い合わせ内容',
  inquiryQuestionPlaceholder: '共通の問い合わせ内容を入力してください',
  pleaseEnterInquiryQuestion: '問い合わせ内容を入力してください',
  inquiryRecords: '商品問い合わせ履歴',
  noInquiryRecords: '問い合わせ履歴はありません',
  taskId: 'タスクID',
  refinedAnswers: '抽出された回答',
  noRefinedAnswers: '抽出結果はありません',
  dialogueContent: '会話内容',
  noDialogueContent: '会話内容はありません',
};
